import React from 'react'

import { FormikProps } from 'formik'

import { EditSupplierFormDto, SupplierDetail } from '../data'
import { Email } from './Email'
import { PrimaryContact } from './PrimaryContact'
import { SupplierFormFieldName } from './Supplier.data'
import { SupplierInformation } from './SupplierInformation'
import { Title } from './Title'
import { WebEdiDeliveryForecastSettings } from './WebEdiDeliveryForecastSettings'
import { WebEdiEInvoiceSettings } from './WebEdiEInvoiceSettings'
import { WebEdiOrderSettings } from './WebEdiOrderSettings'

type Props = {
  isEdit: boolean
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>
  formik: FormikProps<EditSupplierFormDto>
  supplier?: SupplierDetail
  isLoading: boolean
  isFormFieldInvalid: (name: SupplierFormFieldName) => boolean
  getFormErrorMessage: (name: SupplierFormFieldName) => JSX.Element
  wrongSupportEmails: string[] | null
  wrongInboundEmails: string[] | null
  wrongOutboundEmails: string[] | null
  separator: string
  activateSupplier: () => Promise<void>
  deactivateSupplier: () => Promise<void>
  isRequestRunning: boolean
}

export const SupplierView: React.FC<Props> = ({
  isEdit,
  setIsEdit,
  formik,
  supplier,
  isLoading,
  isFormFieldInvalid,
  getFormErrorMessage,
  wrongSupportEmails,
  wrongInboundEmails,
  wrongOutboundEmails,
  separator,
  activateSupplier,
  deactivateSupplier,
  isRequestRunning,
}) => {
  return (
    <>
      <Title
        isLoading={false}
        supplier={supplier}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        formik={formik}
        activateSupplier={activateSupplier}
        deactivateSupplier={deactivateSupplier}
        isRequestRunning={isRequestRunning}
      />

      <SupplierInformation
        isEdit={isEdit}
        isLoading={isLoading}
        formik={formik}
        isFormFieldInvalid={isFormFieldInvalid}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <PrimaryContact
        formik={formik}
        separator={separator}
        isFormFieldInvalid={isFormFieldInvalid}
        wrongSupportEmails={wrongSupportEmails}
        getFormErrorMessage={getFormErrorMessage}
        isEdit={isEdit}
        isLoading={isLoading}
        isRequestRunning={isRequestRunning}
      />

      <WebEdiOrderSettings
        isEdit={isEdit}
        isLoading={isLoading}
        formik={formik}
        isFormFieldInvalid={isFormFieldInvalid}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <WebEdiDeliveryForecastSettings
        isEdit={isEdit}
        isLoading={isLoading}
        formik={formik}
        isFormFieldInvalid={isFormFieldInvalid}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <WebEdiEInvoiceSettings
        isEdit={isEdit}
        isLoading={isLoading}
        formik={formik}
        isFormFieldInvalid={isFormFieldInvalid}
        getFormErrorMessage={getFormErrorMessage}
        isRequestRunning={isRequestRunning}
      />

      <Email
        formik={formik}
        separator={separator}
        isFormFieldInvalid={isFormFieldInvalid}
        wrongInboundEmails={wrongInboundEmails}
        wrongOutboundEmails={wrongOutboundEmails}
        getFormErrorMessage={getFormErrorMessage}
        isEdit={isEdit}
        isLoading={isLoading}
        isRequestRunning={isRequestRunning}
      />
    </>
  )
}
